export enum AppRoutes {
  DEFAULT = "/",
  LOGIN = "/login",
  HOME = "/home", //! REPLACE
  WORKER_LIST = '/workers',
  WORKER_DETAILS = '/workers/:id'
}
